// 测面滑动菜单效果
const SHOW_MENU = true
const HIDE_MENU = false

const sortList = {
  state: {
    isShow: false,
    detail: {
      content: [
        {
          'id': 0,
          name: '按时间从新到旧排序',
          type: 'mtime',
          action: 'desc',
          showBorder: true
        },
        {
          'id': 1,
          name: '按时间从旧到新排序',
          type: 'mtime',
          action: 'asc',
          showBorder: true
        },
        {
          'id': 2,
          name: '按从大到小排序',
          type: 'size',
          action: 'desc',
          showBorder: true
        },
        {
          'id': 3,
          name: '按从小到大排序',
          type: 'size',
          action: 'asc',
          showBorder: true
        },
        {
          'id': 4,
          name: '按名称A-Z排序',
          icon: 'icon-delete',
          count: 'none',
          type: 'name',
          action: 'asc',
          showBorder: true
        },
        {
          'id': 4,
          name: '按名称Z-A排序',
          type: 'name',
          action: 'desc',
          showBorder: true
        }
      ]
    }
  },
  mutations: {
    showSortList (state, obj) {
      state.detail = state.detail
      state.isShow = SHOW_MENU
    },
    hideSortList (state) {
      // state.detail = {}
      state.isShow = HIDE_MENU
    }
  },
  actions: {
    showSortList ({commit}, obj) {
      commit('showSortList', obj)
    },
    hideSortList ({commit}) {
      commit('hideSortList')
    }
  },
  getters: {
    getSortShow: state => state.isShow,
    getSortInfo: state => state.detail
  }
}
export default sortList



// WEBPACK FOOTER //
// ./src/store/modules/sortlist.js